<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { printPage } from '@utils';

import { XLink, XButton } from '@clicksign/excalibur';
import CompanyInfo from '@components/CompanyInfo.vue';
import CertifyInfo from '@components/CertifyInfo.vue';

const store = useStore();
const { t } = useI18n();

const validDocument = computed(() => store.getters['validateAccess/validDocument']);
</script>

<template>
  <section :class="$style.documentValidatorResult">
    <header :class="$style.header">
      <XLink
        no-padding
        to="/"
      >
        {{ t('general.action.returnToHome') }}
      </XLink>
      <XLink
        icon="print"
        to="#"
        no-padding
        @click="printPage"
      >
        {{ t('accessTerm.display.print') }}
      </XLink>
    </header>

    <div :class="$style.info">
      <img
        src="@assets/images/icons/finished.svg"
        :class="$style.image"
      />

      <div>
        <h3>{{ t('accessTerm.result.seeTheDocument') }}</h3>
        <p>
          {{ validDocument.accessible_until }}
          <XLink
            to="https://ajuda.clicksign.com/article/347-como-validar-um-documento-impresso"
            target="_blank"
            no-padding
          >
            {{ t('accessTerm.display.more_info') }}
          </XLink>
        </p>
        <div>
          <XButton
            :to="validDocument.content_url"
            size="sm"
            target="_blank"
          >
            {{ t('accessTerm.result.seeDocument') }}
          </XButton>
          <XLink
            :class="$style.linkDownload"
            :to="validDocument.download"
            :download="validDocument.name"
            target="_blank"
          >
            {{ t('accessTerm.result.downloadDocument') }}
          </XLink>
        </div>
      </div>
    </div>

    <CompanyInfo
      :document="validDocument"
      :is-access-term="false"
    />

    <CertifyInfo :valid-document="validDocument" />
  </section>
</template>

<style lang="scss" module>
.documentValidatorResult {
  .header {
    display: flex;
    justify-content: space-between;

    @media print {
      display: none;
    }
  }

  .info {
    display: flex;
    margin: var(--space-medium) 0 var(--space-large-x) 0;
    padding: var(--space-regular) var(--space-regular) var(--space-regular) 0;
    background-color: var(--color-brand-support-02-50);

    @media print {
      display: none;
    }
  }

  .linkDownload {
    margin-left: var(--space-regular);
  }
}
</style>
